export default function arrayify(obj) {
  let newArray = []
  const objKeys = Object.keys(obj).sort()
  objKeys.forEach(key => {
    newArray.push(obj[key])
  })
  return newArray
}
